module.exports = "/assets/3ad2022a339a617fbf3413a9c21c6efb.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/VT.png
// module id = 3057
// module chunks = 0